<template>
  <div class="layout-view">
    <div class="layout-view__controls">
      <div class="flex space-between w-full">
        <div class="header-controls">
          <UiSearchInput 
            v-model="searchQuery"
            :placeholder="'activities.search' | translate"
            class="search-component"
          />
        </div>
        <div class="header-left">
          <template v-if="!isMobile">
            <v-btn
              medium
              :disabled="isConsultant"
              @click="onCreateOpen"
            >
              <v-icon
                class="mr-2"
                position-left
                font-size="1"
                icon="plus"
              />
              <span>{{ 'base.add_farm' | translate }}</span>
            </v-btn>
          </template>
          <template v-else>
            <v-btn
              fab
              @click="onCreateOpen"
            >
              <v-icon
                font-size="1.2"
                icon="plus"
              />
            </v-btn>
          </template>
        </div>
      </div>
    </div>
    
    <farm-card-list
      ref="farmCardList"
      :searchQuery="searchQuery"
      @select="onSelect"
    />
    
    <v-dialog
      max-width="350"
      v-model="modals.showDetail"
    >
      <detail-modal
        :selected="selectedItem"
        @update="refreshFarms"
        @close="onClose"
      />
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'

import adaptationMixin from '@/mixins/adaptation.mixin.js'
import UiSearchInput from '@/components/ui/ui-search-input/UiSearchInput'

import DetailModal from './modals/DetailModal'
import FarmCardList from './FarmCardList'

export default {
  name: 'Farms',

  mixins: [adaptationMixin],

  components: {
    DetailModal,
    FarmCardList,
    UiSearchInput
  },

  data: () => ({
    userType: null,
    name: '',
    modals: {
      showDetail: false
    },
    selectedItem: null,
    searchQuery: '',
    searchTimeout: null
  }),

  computed: {
    ...mapGetters([
      'client'
    ]),

    clientName () {
      return this.isAdmin
        ? this.client.name
        : this.name
    },

    isConsultant () {
      return this.userType === 'consultant'
    }
  },

  async created () {
    try {
      const { data } = await api.account.get()
      this.userType = data.user_type
    } catch (error) {
      console.error('Failed to fetch user type:', error)
      this.userType = null
    }
  },

  mounted () {
    this.loadData()
  },

  beforeDestroy () {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  },

  methods: {
    async loadData () {
      const { data } = await api.account.get()
      const { first_name: firstName, last_name: lastName } = data
      this.name = `${firstName} ${lastName}`
    },

    // onSearchInput () {
    //   if (this.searchTimeout) {
    //     clearTimeout(this.searchTimeout)
    //   }

    //   this.searchTimeout = setTimeout(() => {
    //     if (this.$refs.farmCardList && this.$refs.farmCardList.loadFarms) {
    //       this.$refs.farmCardList.loadFarms()
    //     }
    //   }, 300)
    // },

    refreshFarms () {
      if (this.$refs.farmCardList && this.$refs.farmCardList.loadFarms) {
        this.$refs.farmCardList.loadFarms()
      }
    },

    onCreateOpen () {
      this.selectedItem = null
      this.modals.showDetail = true
    },

    onClose () {
      this.selectedItem = null
      this.modals.showDetail = false
    },

    onSelect (item) {
      this.selectedItem = item
      this.modals.showDetail = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/abstracts/_mixins.scss';
@import '@/sass/abstracts/_variables.scss';

.layout-view__controls {
  margin-bottom: 2rem;
  
  .flex {
    align-items: center;
  }
}

.header-left {
  display: flex;
  align-items: center;
}

.header-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
  justify-content: flex-start;
  max-width: 400px;
}

.search-component {
  flex: 1;
  max-width: 320px;
}

.farms {
  &__layout {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2.5rem;
  }

  &__title {
    font-size: 3rem;
    font-weight: 700;

    @include tablet {
      font-size: 2.5rem;
    }
  }
}

@media (max-width: 768px) {
  .layout-view__controls .flex {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  
  .header-controls {
    justify-content: center;
    max-width: none;
  }
  
  .search-component {
    max-width: none;
  }
  
  .header-left {
    justify-content: center;
  }
}
</style>